// extracted by mini-css-extract-plugin
export var errorIcon = "_nm-1";
export var nameLogo = "_nm-0";